import { render, staticRenderFns } from "./SideBarExtendedMenuItem.vue?vue&type=template&id=2cd0c815&scoped=true&"
import script from "./SideBarExtendedMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideBarExtendedMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarExtendedMenuItem.vue?vue&type=style&index=0&id=2cd0c815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0c815",
  null
  
)

export default component.exports